export default {
    description: "Opis",
    orderingNote: "Uwaga dotycząca zamówienia"
}